export default {
    setWorkspaceAccounts(state, payload) {
        state.workspaceAccounts = payload;
    },
    setWorkspaceAgents(state, payload) {
        state.workspaceAgents = payload;
    },
    setWorkspaceQueues(state, payload) {
        state.workspaceQueues = payload;
    },
    setWorkspaceIsPrivateSend(state, payload) {
        state.workspaceIsPrivateSend = payload;
    },
}